
import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import { useNavigate } from "react-router";

import { Button, Card, CardContent, CardHeader, Checkbox, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, Grid, IconButton, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Tooltip, Typography } from "@mui/material"

import UndoIcon from '@mui/icons-material/Undo';
import ClearIcon from '@mui/icons-material/Clear';
import LowPriorityIcon from '@mui/icons-material/LowPriority';

import moment from "moment";

import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { Layout } from "../../components/Layout"

import { usePages } from "../../hooks/usePages";

import { TablePaginationActions } from "../../helpers/TablePaginationActions";

import { TablePaddingStyle, TableTheadStyle } from "../../styles/TableStyle";
import { DialogActionsStyle, DialogContentStyle } from "../../styles/DialogStyle";

import { ObtenerUsuariosReasignacionCancelacion } from "../../connections/admin/UsuarioConnection";
import { BuscarReasignacionesCancelaciones, CancelarActividad, CancelarActividades, ReasignarActividad, ReasignarActividades } from "../../connections/admin/ActividadConnection";

import { UsuarioReasignacionCancelacionResponse } from "../../interfaces/admin/UsuarioInterface";
import { BuscarReasignacionesCancelacionesResponse } from "../../interfaces/admin/ActividadInterface";

export const ReasignacionCancelacionPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [selectedAll, setSelectedAll] = useState( false );

    const [loading, setLoading] = useState( false );

    const [filtroAplicado, setFiltroAplicado] = useState( false );    

    const [numeroSeguimiento, setNumeroSeguimiento] = useState( '' );
    const [referencia, setRefencia] = useState( '' );

    const [usuario, setUsuario] = useState( 0 );
    const [usuarioArray, setUsuarioArray] = useState<UsuarioReasignacionCancelacionResponse[]>( [] );
    
    const [usuarioAsignacion, setUsuarioAsignacion] = useState( 0 );
    const [usuarioAsignacionTemp, setUsuarioAsignacionTemp] = useState( 0 );
    const [usuarioAsignacionArray, setUsuarioAsignacionArray] = useState<UsuarioReasignacionCancelacionResponse[]>( [] );

    const [rows, setRows] = useState<BuscarReasignacionesCancelacionesResponse[]>( [] );

    const [openCancelar, setOpenCancelar] = useState( false );
    const [loadingCancelacion, setLoadingCancelacion] = useState( false );

    const [openAsignacion, setOpenAsignacion ] = useState( false );
    const [loadingAsignacion, setLoadingAsignacion] = useState( false );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 10 );

    const handleSelectAll = ( value: boolean ) => {

        const newRows =  rows.map( ( e ) => { e.selected = value; return e; });

        setRows( newRows );
        setSelectedAll( value );
    }

    const handleChangeSelected = ( id: string, value: boolean ) => {

        const newRows =  rows.map( ( e ) => { 
            if( e.id === id ){
                e.selected = value; 
            }
            return e; 
        });

        setRows( newRows );
    }    

    const handleBuscar = async () => {

        setFiltroAplicado( true );
        setLoading( true );
        setSelectedAll( false );
        setRows( [] );

        await BuscarReasignacionesCancelaciones({ numeroSeguimiento, idUsuario: usuario }).then( resp => {

            setTimeout(() => {
                
                setRows( resp.map( (e) => { e.selected = false; return e; } ) );
                setLoading( false );
                
            }, 700);

        });

    }

    const handleClearFiltro = () => {

        setFiltroAplicado( false ); 
        setNumeroSeguimiento( '' );
        setUsuario( 0 );        
        setRows( [ ] ); 

        resetPage();

    }

    const handleClose = () => {

        setOpenCancelar( false ); 
        setOpenAsignacion( false ); 
        setRefencia( '' );
        setUsuarioAsignacionTemp(0);
        setUsuarioAsignacion( 0 ); 
    }

    const handleGuardarCancelacion = async () => {

        setLoadingCancelacion( true );

        await CancelarActividad({ numeroSeguimiento: referencia }).then( resp => {

            const { success, message } = resp;

            if( success ){                  

                setTimeout(() => {

                    setRows( rows.filter( ( elem ) => elem.numeroSeguimiento !== referencia ) )

                    setLoadingCancelacion( false );
                    handleClose();
                    handleClearFiltro();

                    dispatch( openSnackbar({ message: message, variant: 'success' }));   
                    
                }, 700);        
                
            }
            else{
                
                dispatch( openSnackbar({ message: message, variant: 'error' }));   
                setLoadingCancelacion( false );

            }     

        });

    }

    const handleGuardarAsignacion = async () => {

        setLoadingAsignacion( true );

        await ReasignarActividad({ numeroSeguimiento: referencia, idUsuario: usuarioAsignacion }).then( resp => {

            const { success, message } = resp;

            if( success ){                  

                setTimeout(() => {

                    setRows( rows.filter( ( elem ) => elem.numeroSeguimiento !== referencia ) )

                    setLoadingAsignacion( false );
                    handleClose();
                    handleClearFiltro();

                    dispatch( openSnackbar({ message: message, variant: 'success' }));  
                    
                }, 700);        
                
            }
            else{ 
                
                dispatch( openSnackbar({ message: message, variant: 'error' }));    
                setLoadingAsignacion( false );

            }

        });

    }

    const handleGuardarCancelaciones = async () => {

        setLoadingCancelacion( true );

        const numerosSeguimiento = rows.filter( (e) => e.selected ).map( (e) => e.numeroSeguimiento );

        await CancelarActividades({ numeroSeguimiento: numerosSeguimiento }).then( resp => {

            const { success, message } = resp;

            if( success ){                       

                setTimeout(() => {

                    const newArray = rows.filter( (e) => {
                        const findElement = numerosSeguimiento.find( (n) => n === e.numeroSeguimiento );
                        if( findElement ){
                            return false;
                        }                        
                        return true;
                    });

                    setRows( newArray );
                    setLoadingCancelacion( false );
                    handleClose();
                    
                    dispatch( openSnackbar({ message: message, variant: 'success' }));  

                }, 700);        
                
            }
            else{

                dispatch( openSnackbar({ message: message, variant: 'error' }));    
                setLoadingCancelacion( false );

            }     

        });

    }

    const handleGuardarAsignaciones = async () => {

        setLoadingAsignacion( true );

        const numerosSeguimiento = rows.filter( (e) => e.selected ).map( (e) => e.numeroSeguimiento );

        await ReasignarActividades({ numeroSeguimiento: numerosSeguimiento, idUsuario: usuarioAsignacion }).then( resp => {

            const { success, message } = resp;

            if( success ){                  

                setTimeout(() => {

                   const newArray = rows.filter( (e) => {
                        const findElement = numerosSeguimiento.find( (n) => n === e.numeroSeguimiento );
                        if( findElement ){
                            return false;
                        }                        
                        return true;
                    });

                    setRows( newArray );
                    setLoadingAsignacion( false );
                    handleClose();
                    
                    dispatch( openSnackbar({ message: message, variant: 'success' }));  

                }, 700);        
                
            }
            else{

                dispatch( openSnackbar({ message: message, variant: 'error' }));     
                setLoadingAsignacion( false );

            }

        });

    }

    useEffect(() => {
        
        async function Obtener(){

            setUsuario( 0 );
            setUsuarioArray( [] );

            await ObtenerUsuariosReasignacionCancelacion().then( resp => {    
                setUsuarioArray( resp );   
                setUsuarioAsignacionArray( resp );   
            });

        }

        Obtener();

    }, []);

    useEffect(() => {
        
        if( openAsignacion && usuarioAsignacionTemp !== 0 && usuarioAsignacionArray.length !== 0 ){
            setUsuarioAsignacion( usuarioAsignacionTemp );
        }   

    }, [ openAsignacion, usuarioAsignacionTemp, usuarioAsignacionArray ]);

    return (        
        <Layout breadcrumbs={[ { text: 'Administración' }, { text: 'Reasignación de casos' } ]} backgroundPaper={false}>

            <Grid container spacing={3} >  
                            
                <Grid size={{ md: 12, xs: 12 }} textAlign={'start'}>

                    <Button startIcon={ <UndoIcon /> } color="secondary" variant="text" sx={{ mt: 1 }} onClick={ () => navigate( '/' ) }> 
                        Regresar
                    </Button> 

                </Grid>      

                <Grid size={{ md: 12, xs: 12 }}>

                    <Card>

                    <CardHeader sx={{ backgroundColor: (theme) => theme.palette.primary.main }} subheader={ <Typography sx={{ fontWeight: '400', color: 'white' }}> Filtro(s) </Typography> }/>

                    <Divider />

                    <CardContent sx={{ p: 3 }}> 

                        <Grid container spacing={3}>

                            <Grid size={{ md: 5, xs: 12 }}>

                                <TextField
                                    fullWidth
                                    label="Número de seguimiento"
                                    placeholder="RT-1"
                                    variant="outlined"
                                    value={ numeroSeguimiento }
                                    onChange={ (e) => setNumeroSeguimiento( e.target.value.toUpperCase() ) }
                                    disabled={ filtroAplicado }
                                    slotProps={{
                                        input: {
                                            autoComplete: 'off'
                                        },
                                        inputLabel: {
                                            shrink: true,
                                        }
                                    }}       
                                /> 

                            </Grid>

                            <Grid size={{ md: 5, xs: 12 }}>

                                <FormControl fullWidth>
                                    <InputLabel>Usuario(s)</InputLabel>
                                
                                    <Select                         
                                        label="Usuario(s)"
                                        value={ usuario }
                                        onChange={ (e) => setUsuario( e.target.value ) }
                                        disabled={ filtroAplicado }
                                    >
                                        <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>     
                                        {
                                            usuarioArray.map( ( elem ) => (
                                                <MenuItem key={ elem.idUsuario } value={ elem.idUsuario }> { elem.nombreCompleto } </MenuItem>    
                                            ))
                                        }                                           
                                    </Select>

                                </FormControl>

                            </Grid>

                            <Grid size={{ md: 2, xs: 12 }}>

                                <Button 
                                    fullWidth
                                    color={ filtroAplicado ? 'secondary' : 'primary' }  
                                    variant={ filtroAplicado ? 'outlined' : 'contained' }    
                                    onClick={ () => { filtroAplicado ? handleClearFiltro() : handleBuscar() } }                      
                                    disabled={ ( numeroSeguimiento === '' && usuario === 0 ) || loading }
                                > 
                                    { filtroAplicado ? 'limpiar filtro' : 'Buscar'}
                                </Button> 

                            </Grid>

                        </Grid>    

                    </CardContent>    

                    </Card>

                </Grid> 

                <Grid size={{ md: 12, xs: 12 }}>
                    
                    <Grid container spacing={3}>

                        <Grid size={{ md: 8, xs: 0 }}></Grid>
                                        
                        <Grid size={{ md: 2, xs: 12 }}>
                            <Button 
                                fullWidth 
                                variant="contained" 
                                disabled={ rows.filter( (e) => e.selected === true ).length < 2 }
                                onClick={ () => setOpenCancelar( true ) }
                            > 
                                Cancelar
                            </Button> 
                        </Grid>
                        
                        <Grid size={{ md: 2, xs: 12 }}>
                            <Button 
                                fullWidth 
                                variant="contained" 
                                disabled={ rows.filter( (e) => e.selected === true ).length < 2 }
                                onClick={ () => setOpenAsignacion( true ) }
                            >  
                                Reasignar
                            </Button> 
                        </Grid>

                    </Grid>

                </Grid>      

                <Grid size={{ md: 12, xs: 12 }} >

                    <TableContainer sx={{ borderRadius: 3 }} component={ Paper }>
                
                        <Table sx={{ minWidth: 500 }}>
        
                            <TableHead sx={{ ...TableTheadStyle }}>
        
                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>                       

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '19%', fontWeight: 'bold' }}> Número de seguimiento </TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '35%', fontWeight: 'bold' }}> Asignado a </TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '35%', fontWeight: 'bold' }}> Proceso (Módulo) </TableCell>                                                                                                                   
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}> </TableCell>   
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '1%' }}> 
                                        {
                                            rows.length !== 0
                                            &&
                                                <Tooltip title='Seleccionar todo'>
                                                    <Checkbox 
                                                        sx={{ bgcolor: 'white', borderRadius: 2, ':hover': { bgcolor: 'white' } }}
                                                        checked={ selectedAll }
                                                        onChange={ (e) => handleSelectAll( e.target.checked ) }
                                                    />
                                                </Tooltip>
                                        }
                                    </TableCell>     

                                </TableRow>

                            </TableHead>

                            <TableBody>       

                                {
                                    (
                                        rowsPerPage > 0
                                        ?
                                            rows.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                        :
                                            rows
                                    ).map( ( { id, numeroSeguimiento, fecha, actividad, proceso, idUsuario, usuario, idEstatus, selected }, index ) => (

                                        <TableRow key={ index } >     

                                            <TableCell>
                                                                                              
                                                <Typography variant='h6' fontWeight={'bold'}>
                                                    { numeroSeguimiento }                                                     
                                                </Typography> 
                            
                                                <Typography variant='subtitle2' mt={1}>
                                                    { fecha ? moment( fecha ).format("DD-MM-YYYY hh:mm a") : '' }                                                     
                                                </Typography>                                                 
                                            
                                            </TableCell>   

                                            <TableCell> { usuario } </TableCell>

                                            <TableCell>
                                                                                              
                                                <Typography variant='h6' fontWeight={'bold'}>
                                                    { proceso }                                                     
                                                </Typography> 

                                                {
                                                    actividad
                                                    &&
                                                        <Chip 
                                                            variant='filled'
                                                            sx={{ fontWeight: 'bold', mt: 1 }}
                                                            color={ idEstatus === 9 ? 'primary' : idEstatus === 10 ? 'warning' : 'default' }
                                                            label={ 
                                                                <Typography variant='subtitle1' fontWeight={'600'} fontSize={14}> 
                                                                    { actividad }
                                                                </Typography> 
                                                            }
                                                        />                                      
                                                }                                                
                                            
                                            </TableCell>  

                                            <TableCell sx={{ textAlign: 'end' }}> 
                                        
                                                {
                                                    ( idEstatus !== 9 && idEstatus !== 10 )
                                                    &&
                                                        <Tooltip title='Cancelar'>
                                                            <IconButton color='primary' sx={{ mx: 1 }} onClick={ () => { setRefencia( numeroSeguimiento ); setOpenCancelar( true ); }}>
                                                                <ClearIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                }
                                                
                                                {
                                                    ( idEstatus !== 9 && idEstatus !== 10 )
                                                    &&
                                                        <Tooltip title='Reasignar'>
                                                            <IconButton color='primary' onClick={ () => { setRefencia( numeroSeguimiento ); setUsuarioAsignacionTemp( idUsuario ); setOpenAsignacion( true ); }}>
                                                                <LowPriorityIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                }
                                            
                                            </TableCell>

                                            <TableCell>

                                                {
                                                    ( idEstatus !== 9 && idEstatus !== 10 )
                                                    &&
                                                        <Checkbox 
                                                            checked={ selected ?? false }
                                                            onChange={ (e) => handleChangeSelected( id, e.target.checked ) }
                                                        />
                                                }

                                            </TableCell>

                                        </TableRow>
                                    ))
                                }

                                { 
                                    ( rows.length === 0 && !loading )
                                    ?   
                                        <TableRow style={{ height: 93 }}>

                                            <TableCell colSpan={7} align="center"> 

                                                <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>
                                                
                                            </TableCell>

                                        </TableRow>                     
                                    :
                                        loading
                                        &&
                                            <TableRow style={{ height: 93 }}>

                                                <TableCell colSpan={7} align="center"> 

                                                    <CircularProgress size={26} />
                                                    
                                                </TableCell>

                                            </TableRow>                     
                                }                                                              

                            </TableBody>

                            <TableFooter>

                                <TableRow>
                                
                                    <TableCell colSpan={2}>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de registros: { rows.length } </Typography>
                                    </TableCell> 
                                    
                                    <TablePagination 
                                        colSpan={8}
                                        rowsPerPageOptions={[ 5, 10, 15, 20 ]}
                                        count={ rows.length }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }
                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }

                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage="Filas por página"                                            
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                            }
                                        }                                                                                       
                                    />
                                </TableRow>

                            </TableFooter>

                        </Table>
                        
                    </TableContainer>

                </Grid>     

            </Grid>

            <Dialog open={ openCancelar} >

                <DialogTitle>
                    Confirmación
                </DialogTitle>

                <DialogContent sx={ DialogContentStyle }>
                    
                    <DialogContentText>
                        {
                            rows.filter( (e) => e.selected === true ).length < 2
                            ?
                                '¿Desea cancelar el proceso seleccionado?'
                            :
                                '¿Desea cancelar los procesos seleccionados?'
                        }                        
                    </DialogContentText>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>

                    <Button color="secondary" disabled={ loadingCancelacion } onClick={ handleClose }>Cancelar</Button>
                    
                    <Button 
                        variant="contained" 
                        onClick={ () => rows.filter( (e) => e.selected === true ).length < 2 ? handleGuardarCancelacion() : handleGuardarCancelaciones() } 
                        loading={ loadingCancelacion }
                    >
                        Aceptar                        
                    </Button>

                </DialogActions>

            </Dialog>

            <Dialog open={ openAsignacion } maxWidth='sm' fullWidth={true}>

                <DialogTitle>
                    Asignación
                </DialogTitle>

                <DialogContent sx={ DialogContentStyle }>

                    <FormControl fullWidth sx={{ mt: 1 }}>
                        <InputLabel>Usuarios disponibles</InputLabel>
                    
                        <Select                                                        
                            label="Usuarios disponibles"
                            value={ usuarioAsignacion }                                
                            onChange={ ( e ) => { setUsuarioAsignacion( e.target.value ); } }
                        >
                            <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>    
                            {
                                usuarioAsignacionArray.map( ( elem ) => (
                                    <MenuItem key={ elem.idUsuario } value={ elem.idUsuario }> { elem.nombreCompleto } </MenuItem>    
                                ))
                            }                                             
                        </Select>

                    </FormControl>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>

                    <Button color="secondary" onClick={ handleClose }>Cancelar</Button>
                    
                    <Button 
                        variant="contained"      
                        onClick={ () => rows.filter( (e) => e.selected === true ).length < 2 ? handleGuardarAsignacion() : handleGuardarAsignaciones() }   
                        loading={ loadingAsignacion }
                        disabled={ usuarioAsignacion === 0 }
                    >
                        Guardar                        
                    </Button>

                </DialogActions>

            </Dialog>

        </Layout>
    )
}